/** Prontuário de atendimento psicológico (agenda) — persistido no Supabase. */

export const SUPPORT_CENTER_PSYCH_EMOTIONAL_STATES = [
  'Estabilizado',
  'Parcialmente estabilizado',
  'Em crise',
  'Sem avaliação possível',
] as const
export type SupportCenterPsychEmotionalState =
  (typeof SUPPORT_CENTER_PSYCH_EMOTIONAL_STATES)[number]

export const SUPPORT_CENTER_PSYCH_RISK_LEVELS = [
  'Sem risco',
  'Risco leve',
  'Risco moderado',
  'Risco alto',
] as const
export type SupportCenterPsychRiskLevel = (typeof SUPPORT_CENTER_PSYCH_RISK_LEVELS)[number]

export const SUPPORT_CENTER_PSYCH_REFERRALS = [
  'Nenhum',
  'Psiquiatria',
  'Assistência social',
  'UBS / Atenção básica',
  'CAPS',
  'Continuidade na assistência',
  'Outro',
] as const
export type SupportCenterPsychReferral = (typeof SUPPORT_CENTER_PSYCH_REFERRALS)[number]

export type SupportCenterPsychAttendanceFormState = {
  patient_name: string
  insured_number: string
  attendance_date: string
  /** Sequencial: histórico de realizados do paciente + 1 */
  attendance_number: string
  psychologist_name: string
  demand_notes: string
  intervention_notes: string
  patient_response: string
  emotional_state: SupportCenterPsychEmotionalState | ''
  risk_indicator: SupportCenterPsychRiskLevel | ''
  referral: SupportCenterPsychReferral | ''
  next_contact_date: string
  additional_notes: string
}

export type SupportCenterPsychAttendancePayload = {
  appointment_id: string
  patient_cpf: string
  holder_cpf: string
  specialization_id: string
  professional_user_id: string | null
  patient_name: string
  insured_number: string | null
  attendance_date: string
  attendance_number: number
  psychologist_name: string
  demand_notes: string
  intervention_notes: string
  patient_response: string | null
  emotional_state: SupportCenterPsychEmotionalState
  risk_indicator: SupportCenterPsychRiskLevel
  referral: SupportCenterPsychReferral | null
  next_contact_date: string | null
  additional_notes: string | null
}

export const EMPTY_PSYCH_ATTENDANCE_FORM: SupportCenterPsychAttendanceFormState = {
  patient_name: '',
  insured_number: '',
  attendance_date: '',
  attendance_number: '',
  psychologist_name: '',
  demand_notes: '',
  intervention_notes: '',
  patient_response: '',
  emotional_state: '',
  risk_indicator: '',
  referral: '',
  next_contact_date: '',
  additional_notes: '',
}
